import { render } from "./RotasHistorico.vue?vue&type=template&id=c377e86c"
import script from "./RotasHistorico.vue?vue&type=script&lang=js"
export * from "./RotasHistorico.vue?vue&type=script&lang=js"

import "./RotasHistorico.vue?vue&type=style&index=0&id=c377e86c&lang=css"

import exportComponent from "F:\\Projetos 2024\\e-logDash\\node_modules\\@vue\\cli-service\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__